(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-recommendations"] && !Shopify.designMode) return;
  try {
    class ProductListRecommendations extends HTMLElement {
    static observedAttributes = ['data-url'];

    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      this.load(url);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-url' && newValue && newValue !== oldValue) {
        this.#showShimmer(newValue);
        this.load(newValue);
      }
    }

    #showShimmer(url) {
      const limit = new URL(url, location.origin).searchParams.get('limit') || 4;
      let grid = this.querySelector('.product-list__grid');
      if (!grid) {
        grid = document.createElement('ul');
        grid.className = 'product-list__grid';
        grid.setAttribute('role', 'list');
        this.append(grid);
      }
      grid.setAttribute('aria-busy', 'true');
      grid.innerHTML = '<li><div class="product-list__shimmer"></div></li>'.repeat(limit);
    }

    async load(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          this.remove();
          return;
        }

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('product-list-recommendations');

        if (source) {
          this.replaceChildren(...source.childNodes);
        } else {
          this.remove();
        }
      } catch {
        this.remove();
      }
    }
  }

  if (!customElements.get('product-list-recommendations')) {
    customElements.define('product-list-recommendations', ProductListRecommendations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-list"] && !Shopify.designMode) return;
  try {
    class ProductListRecommendations extends HTMLElement {
    static observedAttributes = ['data-url'];

    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      this.load(url);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-url' && newValue && newValue !== oldValue) {
        this.load(newValue);
      }
    }

    async load(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          this.remove();
          return;
        }

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('product-list-recommendations');

        if (source) {
          this.replaceChildren(...source.childNodes);
        } else {
          this.remove();
        }
      } catch {
        this.remove();
      }
    }
  }

  if (!customElements.get('product-list-recommendations')) {
    customElements.define('product-list-recommendations', ProductListRecommendations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["recently-viewed"] && !Shopify.designMode) return;
  try {
    class RecentlyViewedProducts extends HTMLElement {
    async connectedCallback() {
      const key = 'ron-dorff:recently-viewed';
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem(key)) || [];
      } catch (e) {}

      const exclude = this.dataset.excludeHandle;
      if (exclude) {
        handles = handles.filter((handle) => handle !== exclude);
      }

      const limit = parseInt(this.dataset.limit || '4', 10);
      handles = handles.slice(0, limit);

      const grid = this.querySelector('[data-grid]');
      if (!handles.length || !grid) {
        this.remove();
        return;
      }

      const template = this.dataset.cardUrl;

      try {
        const fragments = await Promise.all(
          handles.map(async (handle) => {
            const response = await fetch(template.replace('__HANDLE__', encodeURIComponent(handle)));
            if (!response.ok) return '';
            return await response.text();
          })
        );

        // The Section Rendering API wraps the output in a <div class="shopify-section">,
        // so extract the card <li> from each fragment instead of injecting raw nodes.
        const items = [];
        fragments.forEach((fragment) => {
          if (!fragment) return;
          const parsed = new DOMParser().parseFromString(fragment, 'text/html');
          const item = parsed.querySelector('.recently-viewed__item');
          if (item) items.push(item);
        });

        if (!items.length) {
          this.remove();
          return;
        }

        grid.replaceChildren(...items);
        this.removeAttribute('hidden');
      } catch (e) {
        this.remove();
      }
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
  } catch(e) { console.error(e); }
})();

})();
